import React from 'react';
import PropTypes from 'prop-types';

import style from './ItemInfo.module.css';

const ItemInfo = React.memo(({ show = true, img, text, value }) => {
  return (
    show && (
      <div className={style.item}>
        <img src={img} alt={text} />
        <span>{text}: </span>
        <span>{value}</span>
      </div>
    )
  );
});

ItemInfo.propTypes = {
  show: PropTypes.bool,
  img: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default ItemInfo;
